import { accountsEnvironment } from '../accounts-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { AuthHeaders } from '../../../models/auth-headers';
import { createPagedCollectionSchema } from '../../../utils/create-paged-collection-schema';
import { configurationSettingEntrySchema } from '../schemas/configuration-setting-entry.schema';
import { PagedCollectionParams } from '../../../models/paged-collection-params';
import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

const filterSchema = z.object({
  startTime: z.coerce.date().optional(),
  endTime: z.coerce.date().optional(),
  configurationName: z.string().optional(),
  configurationGroup: z.string().optional(),
  configurationKey: z.string().optional(),
});

/**
 * Get a list of Configuration Settings for a specified Account in a paginated form
 * @param accountAlias Alias of the Account
 * @param filterSchema The filter settings
 * @param offset The offset
 * @returns A list of Configuration Setting Entries
 */
export function getConfigurationSettingsAccountAliasPaginated(
  this: unknown,
  accountAlias: string,
  filter?: z.infer<typeof filterSchema>,
  params?: PagedCollectionParams
) {
  const urlParams = params ? params.params : new URLSearchParams();

  if (filter) {
    if (typeof filter.startTime === 'object') {
      urlParams.append('StartTime', filter.startTime.toISOString());
    }
    if (typeof filter.endTime === 'object') {
      urlParams.append('EndTime', filter.endTime.toISOString());
    }
    if (typeof filter.configurationName === 'string') {
      urlParams.append('ConfigurationName', filter.configurationName);
    }
    if (typeof filter.configurationGroup === 'string') {
      urlParams.append('ConfigurationGroup', filter.configurationGroup);
    }
    if (typeof filter.configurationKey === 'string') {
      urlParams.append('ConfigurationKey', filter.configurationKey);
    }
  }
  return withJwt(() =>
    fromFetch(
      new Request(
        `${accountsEnvironment
          .resolve(this)
          .configurationSettingsAccountAliasPaginatedUrl(
            accountAlias
          )}?${urlParams.toString()}`,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...new AuthHeaders(), // Doesn't work with JWT for some reason
          },
        }
      )
    )
  ).pipe(
    selectData(createPagedCollectionSchema(configurationSettingEntrySchema))
  );
}
